/** Maximum number of error banners shown at the same time */
export const MAX_BANNERS_COUNT = 3;

/** Time (ms) after which a banner hides itself */
export const BANNER_AUTO_HIDE_DURATION = 4000;

/** Appear/disappear animation duration (ms) */
export const BANNER_TRANSITION_DURATION = 300;

/** Colors of the notification mode */
export const NOTIFICATION_BACKGROUND_COLOR = '#FCE5BB';
export const NOTIFICATION_TEXT_COLOR = '#855F01';
